/* USERS */
export const GET_USER = "GET_USER"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_FAIL = "GET_USER_FAIL"

export const GET_USER_DETAILS = "GET_USER_DETAILS"
export const GET_USER_DETAILS_SUCCESS = "GET_USER_DETAILS_SUCCESS"
export const GET_USER_DETAILS_FAIL = "GET_USER_DETAILS_FAIL"

export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

export const UPDATE_ACTIVATION_USER = "UPDATE_ACTIVATION_USER"
export const UPDATE_ACTIVATION_USER_SUCCESS = "UPDATE_ACTIVATION_USER_SUCCESS"
export const UPDATE_ACTIVATION_USER_FAIL = "UPDATE_ACTIVATION_USER_FAIL"

export const UPDATE_DEPARTMENT_USER = "UPDATE_DEPARTMENT_USER"
export const UPDATE_DEPARTMENT_USER_SUCCESS = "UPDATE_DEPARTMENT_USER_SUCCESS"
export const UPDATE_DEPARTMENT_USER_FAIL = "UPDATE_DEPARTMENT_USER_FAIL"

export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

export const EXPORT_USER_EXCEL = "EXPORT_USER_EXCEL"
export const EXPORT_USER_EXCEL_SUCCESS = "EXPORT_USER_EXCEL_SUCCESS"
export const EXPORT_USER_EXCEL_FAIL = "EXPORT_USER_EXCEL_FAIL"

export const RESET_USER_STATE = 'RESET_USER_STATE';
export const RESET_USER_ACTION_STATE = 'RESET_USER_ACTION_STATE';
